import React, { useState, useEffect } from "react";

interface AlertProps {
    code: number;
    message: string;
    onClose: () => void;
}

const Alert: React.FC<AlertProps> = ({ code, message, onClose }) => {
    const isSuccess = code === 0;
    const [showAlert, setShowAlert] = useState<boolean>(true);
    const [progress, setProgress] = useState<number>(100);

    useEffect(() => {
        if(code === -1) return;
        const timer = setInterval(() => {
            setProgress((prevProgress) => prevProgress - 20);
        }, 1000);

        const timeOut = setTimeout(() => {
            setShowAlert(false);
            onClose()
        }, 5000);

        return () => {
            clearInterval(timer);
            clearTimeout(timeOut);
        }
    }, [onClose]);

    const containerClass = `fixed top-4 right-4 z-50 rounded-md p-4 ${isSuccess ? 'bg-green-300 text-green-900' : 'bg-red-300 text-red-900'}`;
    const progressBarClass = `h-1 rounded-full overflow-hidden ${isSuccess ? 'bg-green-500' : 'bg-red-500'}`;
    
    if(code === -1 || !showAlert) {
        return null;
    }

    return (
        <div className={containerClass}>
            <div className='flex justify-between items-center'>
                <h5 className='font-bold mb-2'>{isSuccess ? 'Operation Success' : 'Operation Failed'}</h5>
                <button onClick={() => setShowAlert(false)} className="text-light-gray hover:text-gray mb-2">
                    <svg
                        className="h-5 w-5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
            <p>{message}</p>
            <div className="bg-gray-200 rounded-full overflow-hidden mt-2">
                <div className={progressBarClass} style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    )
}

export default Alert